import DefaultDialogController from 'utils/notifications/default-dialog-controller';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { addWidget, getWidgetsList } from 'dashboard/actions/dashboard.actions';

const DIRTY_FORM = 'dashboard';

const mapStateToThis = (state) => ({
  widgetsList: state.dashboard.widgets,
});

const mapDispatchToThis = {
  getWidgetsList,
  addWidget,
  setDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog')
class RwAddWidgetController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
  }

  $onInit() {
    this.headers = [
      {
        text: this.gettextCatalog.getString('Name'),
      },
      {
        text: this.gettextCatalog.getString('Actions'),
      },
    ];

    this.getWidgetsList(this.retailerType);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onAddWidget(widgetData) {
    this.setDirtyForm(this.DIRTY_FORM, true);
    this.addWidget(widgetData);
    this.getWidgetsList(this.retailerType);
  }
}

export default RwAddWidgetController;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-add-widget/rw-add-widget-controller.js